import React, { useState, useEffect } from 'react';

const Countdown = ({ targetDate, title = "Event Countdown" }) => {
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const countdownTimer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => {
            clearTimeout(countdownTimer);
        };
    });

    const { days, hours, minutes, seconds } = timeLeft;

    if (Object.keys(timeLeft).length === 0) {
        return (
            <div className='text-center'>
                <div className='text-lg font-semibold text-gray-600'>
                    Pendaftaran telah dibuka!
                </div>
            </div>
        );
    }

    const formatTargetDate = () => {
        const date = new Date(targetDate);
        return date.toLocaleString('id-ID', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'short'
        });
    };

    return (
        <div className='text-center'>
            <div className='text-lg font-semibold mb-2 text-gray-700'>
                {title}
            </div>
            <div className='text-sm text-gray-600 mb-3'>
                {formatTargetDate()}
            </div>
            <div className='flex justify-center mt-4'>
                <div className='mr-4'>
                    <span className='text-2xl font-semibold'>{days || 0}</span>
                    <span className='text-gray-600'> Days</span>
                </div>
                <div className='mr-4'>
                    <span className='text-2xl font-semibold'>{hours || 0}</span>
                    <span className='text-gray-600'> Hours</span>
                </div>
                <div className='mr-4'>
                    <span className='text-2xl font-semibold'>{minutes || 0}</span>
                    <span className='text-gray-600'> Minutes</span>
                </div>
                <div>
                    <span className='text-2xl font-semibold'>{seconds || 0}</span>
                    <span className='text-gray-600'> Seconds</span>
                </div>
            </div>
        </div>
    );
};

export default Countdown;
